import { getBrowserLanguage } from 'pages/views/payments/helpers';
import { Currency } from 'root/apps/QuoteMachineIntegration/state/Currency';

export type locale = 'en-US' | 'fr-FR' | 'de-DE' | 'es-ES' | 'nl-NL';

export function getLanguage(localizeValue?: string): locale {
  let currentLocalValue = getBrowserLanguage();
  if (localizeValue) {
    currentLocalValue = localizeValue;
  }

  switch (currentLocalValue) {
    case 'en':
      return 'en-US';
    case 'fr':
      return 'fr-FR';
    case 'de':
      return 'de-DE';
    case 'es':
      return 'es-ES';
    case 'nl':
      return 'nl-NL';
    default:
      return 'en-US';
  }
}

export function getTimezone(): string {
  return window.merchantos.session.getShop()?.timeZone ?? 'UTC';
}

export function getCurrency(): Currency {
  const {
    locale: { currency_symbol: currencySymbol, currency_code: currencyCode },
  } = window.merchantos;

  return {
    currencySymbol,
    currencyCode,
  };
}

export function getDateFormat(): string {
  const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';
  const formatTest = /(?=.*?\bMM)(?=.*?\bDD)(?=.*?\bYYYY).*/;
  let dateFormat;

  dateFormat = window.merchantos.locale.date_format;

  dateFormat = dateFormat.replace('m', 'MM').replace('d', 'DD').replace(/y+/i, 'YYYY');

  return formatTest.test(dateFormat) ? dateFormat : DEFAULT_DATE_FORMAT;
}

// PHP date tokens → Luxon tokens (numeric date formats only — the merchant
// date_format is constrained to these). Unknown chars (separators) pass through.
const PHP_TO_LUXON: Record<string, string> = {
  d: 'dd', // day, leading zero
  j: 'd', // day, no leading zero
  m: 'MM', // month, leading zero
  n: 'M', // month, no leading zero
  Y: 'yyyy', // 4-digit year
  y: 'yy', // 2-digit year
};

/**
 * The merchant's date format as Luxon tokens, for components that format/parse
 * with Luxon (e.g. @lightspeed/cirrus-datepicker). Source of truth is the
 * merchant option window.merchantos.locale.date_format (a PHP format string).
 * Returns undefined when the option is unset so the caller can fall back to its
 * own (library) default rather than an invented one.
 */
export function getLuxonDateFormat(): string | undefined {
  const phpFormat = window.merchantos?.locale?.date_format;
  if (!phpFormat) {
    return undefined;
  }
  return phpFormat
    .split('')
    .map((char) => PHP_TO_LUXON[char] ?? char)
    .join('');
}
